var exports = {
  "C": "Cards__lNeynn",
  "Z": "Card__w1kGtv",
};

module.exports = exports;
